<template lang="pug">
  .b-audio-recorder
    section.b-audio-recorder__controls(
      ref="mainSection"
    )
      canvas.b-audio-recorder__visualizer(
        :class="{'_inactive': !recording}"
        ref="canvas"
        :width="`${layoutScale * 96}px`"
        :height="`${layoutScale * 32}px`"
      )
      button.b-button._icon._fa(
        v-if="!recording"
        @click="startRec"
        type="button"
      )
        font-awesome-icon(
          icon="microphone"
          :style="iconStyle"
          fixed-width
        )
      button.b-button._icon._fa(
        v-else
        @click="stopRec"
        type="button"
      )
        font-awesome-icon(
          icon="stop"
          :style="iconStyle"
          fixed-width
        )
      button.b-button._icon._fa(
        type="button"
        disabled
      )
        font-awesome-icon(
          icon="upload"
          :style="iconStyle"
          fixed-width
        )
      button.b-button._icon._fa(
        v-if="file"
        type="button"
        disabled
      )
        font-awesome-icon(
          icon="download"
          :style="iconStyle"
          fixed-width
        )
</template>

<script>
// import blobToFile from '@/utils/blobToFile';

import { mapFields } from 'vuex-map-fields';

export default {
  name: 'AudioRecorder',
  props: {
    file: String,
  },
  data() {
    return {
      mediaRecorder: null,
      recording: false,
    };
  },
  mounted() {
    this.initRec();
  },
  computed: {
    ...mapFields('scale', [
      'layoutScale',
    ]),
    iconStyle() {
      return {
        'font-size': `${this.layoutScale * 12}px`,
      };
    },
  },
  methods: {
    initRec() {
      if (!navigator.mediaDevices.getUserMedia) {
        console.error('AudioRecorder - `getUserMedia` is not supported on this browser');
        return false;
      }

      const $vm = this;

      let chunks = [];

      let onSuccess = function (stream) {
        const mediaRecorder = new MediaRecorder(stream);
        $vm.mediaRecorder = mediaRecorder;

        visualize(stream);

        mediaRecorder.onstop = function (e) {
          // console.log('AudioRecorder - MediaRecorder.stop()');

          // const blob = new Blob(chunks, { 'type': 'audio/ogg; codecs=opus' });
          const blob = new Blob(chunks, { 'type': 'audio/wav; codecs=0' });
          const audioURL = window.URL.createObjectURL(blob);
          // const clipName = `rec_${Date.now().toString()}`;
          // const file = blobToFile(blob, `${clipName}.wav`);
          $vm.$emit('stopped', audioURL);

          chunks = [];
        };

        mediaRecorder.ondataavailable = function (e) {
          chunks.push(e.data);
        };
      };

      let onError = function (error) {
        console.log('AudioRecorder - error:', error);
      };

      const constraints = { audio: true };
      navigator.mediaDevices.getUserMedia(constraints)
        .then(onSuccess, onError);

      const canvas = this.$refs.canvas;
      if (!canvas) {
        return false;
      }

      // Visualiser setup. Create web audio api context and canvas.
      let audioCtx;

      const canvasCtx = canvas.getContext('2d');

      const AudioContext = window.AudioContext // Default
        || window.webkitAudioContext // Safari and old versions of Chrome
        || false;

      if (!AudioContext) {
        console.warn('No AudioContext');
        return false;
      }

      function visualize(stream) {
        if (!audioCtx) {
          audioCtx = new AudioContext();
        }

        const source = audioCtx.createMediaStreamSource(stream);

        const analyser = audioCtx.createAnalyser();
        analyser.fftSize = 64;
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);

        source.connect(analyser);
        //analyser.connect(audioCtx.destination);

        const WIDTH = canvas.width;
        const HEIGHT = canvas.height;
        canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);

        function draw() {
          const drawVisual = requestAnimationFrame(draw);

          analyser.getByteFrequencyData(dataArray);

          canvasCtx.fillStyle = 'rgb(255, 255, 255)';
          canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);
          let barWidth = (WIDTH / bufferLength) * 2.5;
          let barHeight;
          let x = 0;
          for (var i = 0; i < bufferLength; i++) {
            barHeight = dataArray[i] / 2;
            // canvasCtx.fillStyle = `rgba(116, 116, 116, ${barHeight / HEIGHT + 0.25})`;
            canvasCtx.fillStyle = 'rgb(116, 116, 116)';
            let y = HEIGHT - barHeight / 4;
            let h = barHeight;
            // Set min height.
            if (h < 1) {
              h = -2;
            }
            canvasCtx.fillRect(x, y, barWidth, h);

            x += barWidth + 1;
          }
        }

        draw();
      }
    },
    startRec() {
      const mediaRecorder = this.mediaRecorder;
      mediaRecorder.start();
      // console.log('AudioRecorder - recorder started - mediaRecorder.state:', mediaRecorder.state);
      this.recording = true;
    },
    stopRec() {
      const mediaRecorder = this.mediaRecorder;
      mediaRecorder.stop();
      // console.log('AudioRecorder - recorder stopped - mediaRecorder.state:', mediaRecorder.state);
      // mediaRecorder.requestData();
      this.recording = false;
    },
  },
};
</script>
